// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1305":"516883f60e14c264","3409":"7063cd84dba76976","7553":"6ba9c8eaa7ae782d","8064":"d159e0453e8e2561"}[chunkId] + ".css";
};